import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getThreads, getEmployees } from "../../../api/serviceRecordApi";

const ServiceRecordList = () => {
    const [threads, setThreads] = useState([]);
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const openCount = threads.filter(t => t.Status === "Open").length;
    const closedCount = threads.filter(t => t.Status === "Closed").length;
    const isAdmin = user?.user?.LevelId === 1;

    useEffect(() => {
        fetchThreads();
        if (isAdmin) fetchEmployees();
    }, []);

    const fetchThreads = async () => {
        try {
            const res = await getThreads();
            setThreads(res.data.data || []);
        } catch (err) {
            console.error("Error fetching threads:", err);
        }
    };
    const fetchEmployees = async () => {
        try {
            const res = await getEmployees();
            setEmployees(res.data.data || []);
        } catch (err) {
            console.error("Error fetching employees:", err);
        }
    };
    const getStatusBadge = (status) => {
        if (status === "Open") {
            return <span className="badge bg-success px-3 py-2">Open</span>;
        }
        return <span className="badge bg-secondary px-3 py-2">Closed</span>;
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "-";

        return new Date(dateString).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            timeZone: "UTC"
        });
    };

    return (
        <div className="container mt-4">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 className="mb-1">Service Records</h4>
                    <small className="text-muted">
                        Official communication between administration and employees
                    </small>
                </div>

                {isAdmin && (

                    <button
                        className="btn btn-primary"
                        onClick={() => navigate("/service-record/new")}
                    >
                        + Initiate new thread
                    </button>
                )}
            </div>

            {/* Filters (Admin only) */}
            {isAdmin && (
                <div className="row align-items-end mb-3">

                    {/* Employee Filter */}
                    <div className="col-md-4">
                        <label className="form-label mb-1">Filter by Employee</label>
                        <select
                            className="form-select"
                            value={selectedEmployee}
                            onChange={(e) => setSelectedEmployee(e.target.value)}
                        >
                            <option value="">All Employees</option>

                            {employees.map(emp => (
                                <option key={emp.intUserId} value={emp.intUserId}>
                                    {emp.vchFullName}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Status Filter */}
                    <div className="col-md-3">
                        <label className="form-label mb-1">Filter by Status</label>
                        <select
                            className="form-select"
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="">All Status</option>
                            <option value="Open">Open</option>
                            <option value="Closed">Closed</option>
                        </select>
                    </div>

                    {/* Clear Filters */}
                    <div className="col-md-2">
                        <button
                            className="btn btn-outline-secondary w-100"
                            disabled={!selectedEmployee && !selectedStatus}
                            onClick={() => {
                                setSelectedEmployee("");
                                setSelectedStatus("");
                            }}
                        >
                            Clear Filters
                        </button>
                    </div>

                </div>
            )}

            {/* Empty State */}
            {threads.length === 0 && (
                <div className="card text-center p-4 shadow-sm mb-3">
                    <p className="text-muted mb-0">
                        No service records found.
                    </p>
                </div>
            )}

            {/* Thread Counts */}
            <div className="d-flex gap-3 mb-3">
                <span className="badge bg-success px-3 py-2">
                    Open Threads: {openCount}
                </span>

                <span className="badge bg-secondary px-3 py-2">
                    Closed Threads: {closedCount}
                </span>
            </div>

            {/* Thread List */}
            <div className="row">
                {threads
                    .filter(thread =>
                        (!selectedEmployee || thread.EmployeeID == selectedEmployee) &&
                        (!selectedStatus || thread.Status === selectedStatus)
                    )
                    .map((thread) => (
                        <div key={thread.ThreadID} className="col-12 mb-3">
                            <div
                                className="card shadow-sm service-record-card border-0"
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate(`/service-record/${thread.ThreadID}`)}
                            >
                                <div className="card-body">

                                    <div className="d-flex justify-content-between">

                                        {/* Left Content */}
                                        <div>

                                            {/* Subject & Thread ID */}
                                            <h6 className="fw-semibold mb-1">
                                                #{thread.ThreadID} — {thread.Subject}
                                            </h6>

                                            {/* Employee + Authority */}
                                            <div className="small text-muted mb-1">
                                                <span className="me-3">
                                                    <strong>Employee:</strong> {thread.EmployeeName || "-"}
                                                </span>

                                                <span>
                                                    <strong>Authorized By:</strong> {thread.AuthorizedBy}
                                                </span>
                                            </div>

                                            {/* Activity Date */}
                                            <div className="small text-muted">
                                                Last activity:{" "}
                                                {formatDateTime(thread.LastActivityDate || thread.CreatedDate)}
                                            </div>

                                        </div>

                                        {/* Status */}
                                        <div className="text-end">
                                            {getStatusBadge(thread.Status)}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
            </div>

        </div>
    );
};

export default ServiceRecordList;